import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSignOut } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  logoutUser,
  selectUserRole,
  selectHasPermission,
  refreshTokenUser,
} from "../redux/features/auth/authSlice";
import sparkLogo from "../images/spark.png";

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = (path) => location.pathname === path;
  const dispatch = useDispatch();

  const userRole = useSelector(selectUserRole);
  const { auth } = useSelector((state) => state.auth);

  const canCreatePresentations = useSelector((state) =>
    selectHasPermission(state, "create presentations"),
  );

  const [profilePhoto, setProfilePhoto] = useState();
  const isAdmin =
    userRole &&
    ["admin", "super admin", "super"].includes(userRole.toLowerCase());

  useEffect(() => {
    if (auth?.admin?.photo) {
      setProfilePhoto(auth.admin.photo);
    } else {
      setProfilePhoto();
    }
  }, [auth]);

  const handleLogout = async () => {
    try {
      await dispatch(logoutUser()).unwrap();
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <nav className="w-full bg-white py-4 px-6 sm:px-12 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-6">
        <Link to="/" className="flex items-center cursor-pointer">
          <img src={sparkLogo} alt="spark logo" className="h-14 sm:h-16" />
        </Link>

        {profilePhoto && (
          <>
            <div className="h-10 w-px bg-gray-300 hidden sm:block"></div>
            <img
              src={profilePhoto}
              alt="Profile Logo"
              className="h-10 w-auto"
            />
          </>
        )}
      </div>

      <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-6">
        <Link to="/">
          <button
            className={`px-4 py-2 rounded-md text-base sm:text-lg font-semibold transition ${
              isActive("/")
                ? "text-purple-500 font-bold"
                : "text-gray-700 hover:text-purple-400"
            }`}
          >
            Home
          </button>
        </Link>

        <Link to="/presentations">
          <button
            className={`px-4 py-2 rounded-md text-base sm:text-lg font-semibold transition ${
              isActive("/presentations")
                ? "text-purple-500 font-bold"
                : "text-gray-700 hover:text-purple-400"
            }`}
          >
            Presentations
          </button>
        </Link>
        {isAdmin && (
          <Link to="/roles">
            <button
              className={`px-4 py-2 rounded-md text-base sm:text-lg font-semibold transition ${
                isActive("/roles")
                  ? "text-purple-500 font-bold"
                  : "text-gray-700 hover:text-purple-400"
              }`}
            >
              Roles
            </button>
          </Link>
        )}
        {isAdmin && (
          <Link to="/brands">
            <button
              className={`px-4 py-2 rounded-md text-base sm:text-lg font-semibold transition ${
                isActive("/brands")
                  ? "text-purple-500 font-bold"
                  : "text-gray-700 hover:text-purple-400"
              }`}
            >
              Brands
            </button>
          </Link>
        )}
        {isAdmin && (
          <Link to="/admin">
            <button
              className={`px-4 py-2 rounded-md text-base sm:text-lg font-semibold transition ${
                isActive("/admin")
                  ? "text-purple-500 font-bold"
                  : "text-gray-700 hover:text-purple-400"
              }`}
            >
              Admin
            </button>
          </Link>
        )}

        {canCreatePresentations && (
          <Link to="/creating-presentation">
            <button
              className={`px-4 py-2 rounded-lg font-semibold border-2 border-lightPurple transition flex items-center gap-2 ${
                isActive("/creating-presentation")
                  ? "text-purple-400"
                  : "text-lightPurple hover:text-white hover:bg-lightPurple"
              }`}
            >
              <FontAwesomeIcon icon={faPlus} className="text-sm" />
              Start Creating
            </button>
          </Link>
        )}

        <button
          onClick={handleLogout}
          className="px-4 py-2 rounded-md text-base sm:text-lg font-semibold text-gray-700 hover:text-purple-400 transition flex items-center gap-2"
        >
          <FontAwesomeIcon icon={faSignOut} />
          Logout
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
